import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import './badgeshome.scss';


const BadgesHomeSection = ({ payload }) => {
  const { badgeshome } = payload;
  const { t } = useTranslation();

  if (!badgeshome) return null;

  return (
    <section id="badges" className="badgessection">
      <div className="other-ways-heading">
        <h3>{t(badgeshome.title)}</h3>
      </div>
      <div className="ss-badges">
        {badgeshome.images?.map((src, index) => {
          const isSeal = /iso|27001/i.test(src);
          return (
            <img
              key={index}
              src={src}
              alt={`badge-${index + 1}`}
              className={isSeal ? 'ss-badges__img--seal' : undefined}
            />
          );
        })}
      </div>
    </section>
  );
};

export default BadgesHomeSection;